<template>
  <div class="details-component">
    <div class="buttonset">
      <router-link class="btn btn--secondary" :to="{ name: 'report-conference-products' }">{{ $t('conferencereport.return_to_selection') }}</router-link>&nbsp;
    </div>
    <div class="details-component__header">
      <h1>{{ $t('conferencereport.title') }}</h1>
    </div>
    <div v-if="productLoaded && parkingsLoaded">
      <h3>{{ $t('conferencereport.for_conference') }} {{ product.name }}</h3>
      <p>
        {{ $t('conferencereport.price_per_vehicle') }} {{ product.price }}€<br>
        {{ $t('conferencereport.number_of_vehicles') }} {{ conferenceParkings.length }}
      </p>
      <p>{{ $t('conferencereport.total_price') }} {{ calculateTotalPrice() }}€</p>
      <p>{{ $t('conferencereport.registered_vehicles') }}</p>
      <div class="parkingContainer">
        <div class="parking" v-for="parking in conferenceParkings" v-bind:key="parking.id">
          {{ parking.vehicleReg }}
        </div>
      </div>
    </div>
    <div v-else>
      <h2>{{ $t('conferencereport.loading') }}</h2>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';

export default {
  computed: {
    ...mapGetters({
      selectedProductId: 'products/product/selectedProductId',
      conferenceParkings: 'parkings/parkings/parkings',
      productName: 'products/product/name',
      productError: 'products/product/error',
      product: 'products/product/product',
      user: 'user/user/user',
    }),
  },
  watch: {
    $route: 'fetchProduct',
  },
  mounted() {
    this.productLoaded = false;
    this.parkingsLoaded = false;
    this.fetchProduct();
    this.fetchConferenceParkings();
  },
  methods: {
    fetchProduct() {
      if (this.$route.params.id) {
        this.$store.dispatch('products/product/fetch', { id: this.$route.params.id, user: this.user }).then(() => {
          this.productLoaded = true;
        });
      } else {
        this.$store.commit(`${this.role()}/product/${mTypes.CLEAR_STATE}`);
      }
    },
    fetchConferenceParkings() {
      if (this.$route.params.id && this.user.data) {
        this.$store.dispatch('parkings/parkings/fetchConference', { id: this.$route.params.id, user: this.user }).then(() => {
          this.parkingsLoaded = true;
        });
      }
    },
    isConferenceParking() {
      return this.product.type === 'conferenceParking';
    },
    role() {
      return this.isLandlord() ? 'products' : 'tenants';
    },
    calculateTotalPrice() {
      return this.conferenceParkings.length * this.product.price;
    },
  },
  data() {
    return {
      productLoaded: false,
      parkingsLoaded: false,
    };
  },
};
</script>
<style lang="scss" scoped>
@import '~styles/app.scss';
@import '~styles/variables.scss';
@import '~styles/_mixins.scss';
.parkingContainer {
  max-width: 100%;
  column-count: 15;
  column-width: 64px;
  column-rule: 1px solid var(--grey-five);
}
.parking {
  padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/products/ConferenceReportView.vue